import {ENDPOINT_ADMIN_MERCHANT_FILTER, ENDPOINT_ADMIN_MERCHANT_SET_LIMITS} from "../../constants/api";

const cancelablePromiseResolve = require('mn-utils/CancelablePromise').resolve;
const {
  apiRequestAdmin,
} = require('../ws');

export function apiAdminMerchantSetLimits(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_MERCHANT_SET_LIMITS, params);
}


export function apiAdminMerchantsFilter(params) {
  params = params || {};
  const email = params.email || '';

  return email.length > 1
    ? apiRequestAdmin(ENDPOINT_ADMIN_MERCHANT_FILTER, {
      ...params,
      email,
      offset: params.offset || 0,
      limit: params.limit || 50,
    })
    : cancelablePromiseResolve({
      list: [],
      count: 0,
    });
}
